export type RenderElement = JSX.Element | JSX.Element[] | null;

export const CONTENT_DIVIDER = "|";
export const DATE_ONLY_FORMAT = "YYYY-MM-DD";
export const DATE_ONLY_NO_DAY = "YYYY-MM";